import mock from '../mocks/council';

export function useCouncil() {
  const counselor = mock;
  return counselor;
};